import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import { Plug } from 'lucide-react';
import { useEffect, useState } from 'react';
import { httpClient } from '../../../common/httpclient';
import CenterModal from './CenterModal';

// Integração do caixa — modal central (§5.6).
//
// Correção de bug (o caixa NÃO se conecta com nenhuma maquininha — não existe
// essa funcionalidade real): o único dado real de integração exposto pela API
// é o código de integração, retornado como `CodeIntegration` (sem tag json,
// ver `cashFlowViewResponse` em `cashregister/viewer.go`) por
// `GET /cashregister/{id}/view`. Não há cadastro de maquininha vinculada nem
// sincronização automática — a versão anterior deste modal simulava seleção
// de dispositivo (via `/cardmachines`) e um toggle de "sincronizar vendas
// automaticamente", nenhum dos dois com suporte real no backend. Este modal
// mostra somente o código, com uma ação para copiar.
//
// A Lista não traz esse código em lote (`cashRegisterListResponse` só tem
// id/name/status/available_cash), então ele é buscado aqui mesmo ao abrir o
// modal.
export default function IntegrationModal({ open, onClose, cashRegister }) {
    const [loading, setLoading] = useState(false);
    const [code, setCode] = useState('');
    const [copied, setCopied] = useState(false);

    useEffect(() => {
        if (!open || !cashRegister?.id) return;
        setCopied(false);
        setLoading(true);
        httpClient.get(`/cashregister/${cashRegister.id}/view`)
            .then((response) => setCode(response.data?.CodeIntegration || ''))
            .catch((error) => {
                console.error('Erro ao carregar código de integração:', error);
                setCode('');
            })
            .finally(() => setLoading(false));
    }, [open, cashRegister]);

    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(code);
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        } catch (error) {
            console.error('Erro ao copiar código de integração:', error);
        }
    };

    return (
        <CenterModal
            open={open}
            onClose={onClose}
            icon={Plug}
            title="Integração da Impressora Fiscal"
            description={cashRegister ? `Código de integração de "${cashRegister.name}". Este código é usado para configurar a impressora fiscal.` : ''}
            onConfirm={code ? handleCopy : undefined}
            confirmText={copied ? 'Copiado!' : 'Copiar código'}
        >
            <Typography sx={{ fontSize: '10.5px', fontWeight: 800, color: 'text.secondary', textTransform: 'uppercase', letterSpacing: '.05em', mb: '6px' }}>
                Código de integração
            </Typography>
            <Box sx={{
                display: 'flex',
                alignItems: 'center',
                minHeight: 46,
                p: '12px 14px',
                border: '1px solid',
                borderColor: 'divider',
                borderRadius: '11px',
                bgcolor: 'background.subtle',
            }}>
                {loading ? (
                    <CircularProgress size={16} thickness={5} />
                ) : (
                    <Typography sx={{ fontSize: '13.5px', fontWeight: 700, fontFamily: 'monospace', wordBreak: 'break-all', color: code ? 'text.primary' : 'text.disabled' }}>
                        {code || 'Nenhum código de integração cadastrado para este caixa.'}
                    </Typography>
                )}
            </Box>
        </CenterModal>
    );
}
